import { useRouter } from 'next/router'

import { getUrlString } from '@/lib/utils'

import useFetch from './useFetch'

export default function useSite() {
  const router = useRouter()
  const siteSlug = getUrlString(router?.query?.site)

  const response = useFetch([siteSlug ? `/${siteSlug}/` : null])
  return { ...response, siteSlug }
}
